import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'auth-divider',
  templateUrl: './auth-divider.component.html',
  styleUrls: ['./auth-divider.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class AuthDividerComponent {
  @Input() label: string = 'lub';
}
